import { Temporal } from '@js-temporal/polyfill';

const DEFAULT_ZONE = 'America/Sao_Paulo';

export function toZonedDateTime(isoString: string) {
  // Check if it's just a date (YYYY-MM-DD) or has time
  try {
    return Temporal.PlainDate.from(isoString).toZonedDateTime(DEFAULT_ZONE);
  } catch {
    // Fallback if full ISO string is provided
    return Temporal.Instant.from(isoString).toZonedDateTimeISO(DEFAULT_ZONE);
  }
}

// Helper: Get "Now" in your app's zone
export function getAppNow() {
  return Temporal.Now.zonedDateTimeISO(DEFAULT_ZONE);
}
